import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'reactstrap';
import OrganizationCoatingInput from './organizationCoatingInput';
const firstDivisions = ['Pitted', 'Rust/Mill Scale', 'Repair 31-50%', 'Repair 11-30%'];
const secondDivisions = ['Repair 1-10%', 'Refurbish', 'Good', 'New'];
const OrganizationConditionCosts = _ref => {
  let coatingScoreDivisions = _ref.organization.coatingScoreDivisions,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("h2", null, "Condition Costs"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, firstDivisions.map((label, index) => /*#__PURE__*/React.createElement(OrganizationCoatingInput, {
    coatingScoreDivisions: coatingScoreDivisions,
    index: index,
    key: "key-".concat(label),
    labelText: label,
    onChange: onChange
  }))), /*#__PURE__*/React.createElement(Row, null, secondDivisions.map((label, index) => /*#__PURE__*/React.createElement(OrganizationCoatingInput, {
    coatingScoreDivisions: coatingScoreDivisions,
    index: index + 4 // add 4 since the firstDivisions have already been rendered
    ,
    key: "key-".concat(label),
    labelText: label,
    onChange: onChange
  }))));
};
OrganizationConditionCosts.propTypes = {
  organization: PropTypes.shape({
    coatingScoreDivisions: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  onChange: PropTypes.func.isRequired
};
export default OrganizationConditionCosts;